import { useEffect, useState } from "react";
import { Button, Typography, message as AntdMessage } from "antd";
import CreateIndustryTypeModal from "../../component/IndustryType/CreateIndustryTypeModal";
import ConfirmationModal from "../../component/common/ConfirmationModal";
import EditIndustryTypeModal from "../../component/IndustryType/EditIndustryTypeModal";
import IndustryTypeTable from "../../component/IndustryType/IndustryTypeTable";
import { createIndustryType, deleteIndustryType, getIndustryTypeById, updateIndustryType, getAllIndustryType } from "../../api/industryType";
const { Title } = Typography;

const IndustryTypeList = () => {
  //-------------States-------------
  const [industryTypeList, setIndustryTypeList] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [lastPage, setLastPage] = useState();
  const [loader, setLoader] = useState(false);
  const [createIndustryTypeModalOpen, setCreateIndustryTypeModalOpen] = useState(false);
  const [confirmationModalOpen, setConfirmationModalOpen] = useState(false);
  const [industryTypeIdToDelete, setIndustryTypeIdToDelete] = useState(null);
  const [industryTypeUpdate, setIndustryTypeUpdate] = useState(null);
  const [editIndustryTypeModalOpen, setEditIndustryTypeModalOpen] = useState(false);
  const [industryTypeIdToEdit, setIndustryTypeIdToEdit] = useState(null);

  //-------------Side_Effects-------------
  useEffect(() => {
    handleFetchIndustryTypes();
  }, [lastPage, currentPage]);


  //-----------API_Calls------------------


  const handleFetchIndustryTypes = async () => {
    try {
      setLoader(true)
      const { success, data, message } = await getAllIndustryType(setIndustryTypeList);
      setLoader(false);
      if(success){
        setLoader(false);

      }else{
        setLoader(false);
        AntdMessage.error(message);

      }

    } finally {
      setLoader(false);
    }
  };


  const handleCreateIndustryType = async (industryType) => {
    try {
      setLoader(true);
      const { success, data, message }  = await createIndustryType(industryType);
      if (success && data) {
        AntdMessage.success(message);
        setLoader(false);
      await handleFetchIndustryTypes();
      } else {
        setLoader(false);
        AntdMessage.error(message);

      }
    } finally {
      setLoader(false);
    }
  };

  const handleDeleteIndustryType = async () => {
    try {
      setLoader(true);
      const { success, message } = await deleteIndustryType(industryTypeIdToDelete);
      if (success) {
        AntdMessage.success(message);
        await handleFetchIndustryTypes();
        setConfirmationModalOpen(false);
      } else {
        AntdMessage.error(message);
      }
    } finally {
      setLoader(false);
      setConfirmationModalOpen(false);
    }
  };

  const fetchIndustryTypeUpdate = async (id) => {
    try {
      setLoader(true);
      const { success, data, message } = await getIndustryTypeById(id);
      if (success) {
        setIndustryTypeUpdate(data);
        setEditIndustryTypeModalOpen(true);
      } else {
        AntdMessage.error(message);
      }
    } finally {
      setLoader(false);
    }
  };

  const handleIndustryTypeEdit = async (updatedData) => {
    try {
      setLoader(true);
      const { success, data, message } = await updateIndustryType(industryTypeIdToEdit, updatedData);
      if (success) {
        AntdMessage.success(message);
        await handleFetchIndustryTypes();
      } else {
        AntdMessage.error(message);
      }
    } finally {
      setLoader(false);
    }
  };



  // -----------------Local Functions--------------
  const showCreateIndustryTypeModal = () => {
    setCreateIndustryTypeModalOpen(true)
  }

  const handleCancel = () => {
    setConfirmationModalOpen(false);
  };

  return (
    <>
      <div className="mt-5" >
        <div className="container" >
          <div className="d-flex align-items-center justify-content-between">
            <div className="col-8">
              <Title level={2}>Industry Types</Title>
            </div>
            <div>
              <Button onClick={showCreateIndustryTypeModal}>+ Industry Type</Button>
            </div>
          </div>
          <div>
          </div>
          <div>

            <IndustryTypeTable
              dataProps={{
                loader,
                data: industryTypeList,
                actions: {
                  setIndustryTypeIdToDelete,
                  setConfirmationModalOpen,
                  setIndustryTypeIdToEdit,
                  fetchIndustryTypeUpdate
                }
              }}
            />
          </div>

          {/* Create Industry Type Modal  */}
          <CreateIndustryTypeModal
            dataProps={{
              open: createIndustryTypeModalOpen,
              setOpen: setCreateIndustryTypeModalOpen,

              actions: {
                handleCreateIndustryType
              }
            }}
          />
          {/* Edit Industry Type Modal  */}
          <EditIndustryTypeModal
            propsData={{
              open: editIndustryTypeModalOpen,
              setOpen: setEditIndustryTypeModalOpen,
              data: industryTypeUpdate,
              actions: {
                handleIndustryTypeEdit,
              }
            }}
          />

          {/* Confirmation Modal  */}
          <ConfirmationModal
            open={confirmationModalOpen}
            onConfirm={handleDeleteIndustryType}
            onCancel={handleCancel}
            content="Are you sure! you want to delete this industry type?"
          />

        </div>
      </div>
    </>
  );
};

export default IndustryTypeList;